(function () {
  const sectionSelector = '#MainContent > .shopify-section, footer > .shopify-section';
  const visibleClass = 'scroll-reveal--visible';
  const revealAttribute = 'data-scroll-reveal-section';
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion) {
    document.documentElement.classList.add('js-scroll-reveal');
    document.querySelectorAll(sectionSelector).forEach((section) => {
      section.setAttribute(revealAttribute, '');
      section.classList.add(visibleClass);
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add(visibleClass);
        observer.unobserve(entry.target);
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.12,
    }
  );

  function revealVisibleSection(section) {
    const rect = section.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight * 0.92 && rect.bottom > 0;

    if (isVisible) {
      section.classList.add(visibleClass);
      return true;
    }

    return false;
  }

  function prepareSections(root) {
    root.querySelectorAll(sectionSelector).forEach((section, index) => {
      if (section.hasAttribute(revealAttribute)) return;

      section.setAttribute(revealAttribute, '');
      section.style.setProperty('--scroll-reveal-delay', `${Math.min(index * 70, 210)}ms`);

      if (!revealVisibleSection(section)) {
        observer.observe(section);
      }
    });
  }

  document.documentElement.classList.add('js-scroll-reveal');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prepareSections(document));
  } else {
    prepareSections(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    prepareSections(event.target.parentElement || document);
  });

  document.addEventListener('shopify:section:select', (event) => {
    event.target?.classList.add(visibleClass);
  });
})();
